import {gql} from "apollo-boost";

export const BULKCREATE_STUDENTUNITLEARN = gql`
  mutation bulkCreateStudentUnitLearn(
    $bulkCreateStudentUnitLearnSets: String
  ) {
    bulkCreateStudentUnitLearn (
      bulkCreateStudentUnitLearnSets: $bulkCreateStudentUnitLearnSets,
    )
    {
      id
      studentEnroll {
        id
      }
      studentEnrollDetail {
        id
      }
      courseOutlineUnit {
        id
        seq
      }
      vdoSetUnit {
        id
        totalVdoLength
      }
      studentTopicLearns {
        id
        studentUnitLearn {
          id
          unitSeq
          totalVdoLength
          totalLearnTime
        }
        studentEnrollDetail {
          id
        }
        vdoSetUnit {
          id
          totalVdoLength
        }
        vdoSetTopic {
          id
          no
        }
        vdoLength
        learnTime
        learnPercent
        firstPlayVdo
        startPlayVdo
        stopPlayVdo
      }
      unitSeq
      totalVdoLength
      totalLearnTime
      learnPercent
    }
  }
`;

export const ADD_STUDENT_UNIT_TOPIC_LEARN = gql`
  mutation addStudentTopicLearn(
    $studentUnitLearnId: ID!,
    $studentEnrollDetailId: ID!,
    $vdoSetUnitId: ID!,
    $vdoSetTopicId: ID!,
    $studentTopicLearnInput: StudentTopicLearnInput!,
  ) {
    addStudentTopicLearn (
      studentUnitLearnId: $studentUnitLearnId
      studentEnrollDetailId: $studentEnrollDetailId
      vdoSetUnitId: $vdoSetUnitId
      vdoSetTopicId: $vdoSetTopicId
      studentTopicLearnInput: $studentTopicLearnInput
    ) {
      id
      learnTime
      learnPercent
      vdoLength
      firstPlayVdo
      startPlayVdo
      stopPlayVdo
      studentUnitLearn {
        id
        totalLearnTime
        learnPercent
      }
      studentEnrollDetail {
        id
      }
      vdoSetUnit {
        id
        totalVdoLength
      }
      vdoSetTopic {
        id
      }
    }
  }
`


export const ADD_STUDENT_UNIT_AND_TOPIC_LEARN = gql`
  mutation addStudentUnitLearnAndTopic(
    $studentEnrollId: ID
    $studentEnrollDetailId: ID
    $courseOutlineUnitId: ID
    $vdoSetUnitId: ID
    $studentUnitLearnInput: StudentUnitLearnInput!
  ) {
    addStudentUnitLearnAndTopic (
      studentEnrollId: $studentEnrollId
      studentEnrollDetailId: $studentEnrollDetailId
      vdoSetUnitId: $vdoSetUnitId
      courseOutlineUnitId: $courseOutlineUnitId
      studentUnitLearnInput: $studentUnitLearnInput
    ) {
      id unitSeq totalVdoLength totalLearnTime learnPercent
      vdoSetUnit { id }
      courseOutlineUnit { id }
      studentTopicLearns {
        id learnTime learnPercent vdoLength
        firstPlayVdo startPlayVdo stopPlayVdo
        vdoSetTopic { id }
      }
    }
  }
`

export const UPDATE_STUDENT_LEARN_TIME = gql`
  mutation updateStudentLearnTime(
    $studentTopicLearnId:  ID!,
    $learnTime:            Int!,
    $learnPercent:         Int!,
    $studentUnitLearnId:   ID!,
    $totalLearnTime:       Int!,
    $totalLearnPercent:    Int!,
    $stopPlayVdo:          String
  ) {
    updateStudentLearnTime (
      studentTopicLearnId:  $studentTopicLearnId
      learnTime:            $learnTime
      learnPercent:         $learnPercent
      studentUnitLearnId:   $studentUnitLearnId
      totalLearnTime:       $totalLearnTime
      totalLearnPercent:    $totalLearnPercent
      stopPlayVdo:          $stopPlayVdo
    ) {
      studentTopicLearn {
        id
      }
      studentUnitLearn {
        id
      }
    }
  }
`


export const UPDATE_STUDENT_TOPIC_AND_UNIT_LEARN = gql`
  mutation updateStudentTopicAndUnitLearn(
    $studentTopicLearnId: ID!
    $studentTUnitLearnId: ID
    $studentUnitLearnId: ID
    $studentTopicLearnInput: StudentTopicLearnInput!
    $studentUnitLearnInput: StudentUnitLearnInput!
  ) {
    updateStudentTopicAndUnitLearn(
      studentTopicLearnId: $studentTopicLearnId
      studentTUnitLearnId: $studentTUnitLearnId
      studentUnitLearnId: $studentUnitLearnId
      studentTopicLearnInput: $studentTopicLearnInput
      studentUnitLearnInput: $studentUnitLearnInput
    ) {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      vdoSetUnit { id }
      vdoSetTopic { id }
      forceUpdateFrontLearnTime
    }
  }
`;

export const UPDATE_UNSAVED_STUDENT_TOPIC_AND_UNIT_LEARN = gql`
  mutation updateUnsavedStudentTopicAndUnitLearn(
    $studentTopicLearnId: ID!
    $studentTUnitLearnId: ID
    $studentUnitLearnId: ID
    $studentTopicLearnInput: StudentTopicLearnInput!
    $studentUnitLearnInput: StudentUnitLearnInput!
  ) {
    updateUnsavedStudentTopicAndUnitLearn(
      studentTopicLearnId: $studentTopicLearnId
      studentTUnitLearnId: $studentTUnitLearnId
      studentUnitLearnId: $studentUnitLearnId
      studentTopicLearnInput: $studentTopicLearnInput
      studentUnitLearnInput: $studentUnitLearnInput
    ) {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      vdoSetUnit { id }
      vdoSetTopic { id }
    }
  }
`;

export const UPDATE_REVIEW_SOCRE = gql`
  mutation updateReviewScore(
    $id: ID!,
    $reviewScore: Int!
    $reviewTeacherScore: Int!
    $reviewMaterialScore: Int!
    $reviewOverAllScore: Float!
  ) {
    updateReviewScore(
      id: $id
      reviewScore: $reviewScore
      reviewTeacherScore: $reviewTeacherScore
      reviewMaterialScore: $reviewMaterialScore
      reviewOverAllScore: $reviewOverAllScore
    ) {
      id
    }
  }
`;

